import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.trading_data.title',
        defaultMessage: 'Upload Documents'
    },
    uploadNewDocumentType: {
        id: '_.trading_data.upload_new_document_type',
        defaultMessage: 'Upload new document type'
    }
});
